import * as ElIconModules from '@element-plus/icons-vue';
import { ElLoading, ElMessage, ElMessageBox, ElNotification } from '@bilibili/magic-cube-plus';
import '@bilibili/magic-cube-plus/dist/index.css';

export default {
    install(app) {
        // 批量注册 Element Plus 图标组件
        // 或者自定义 ElIconModules 列表
        for (const iconName in ElIconModules) {
            if (Object.prototype.hasOwnProperty.call(ElIconModules, iconName)) {
                app.component(iconName, ElIconModules[iconName]);
            }
        }
        // 将消息提示组件注册为全局方法
        app.use(ElLoading);
        app.use(ElMessage);
        app.use(ElMessageBox);
        app.use(ElNotification);
    }
};
